import * as React from "react";
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
/**
 * Circular Progressbar.
 */
class CircularProgressBar extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { percentage, trialColor, overallScoreColor, rotation, strokeLinecap, pathTransitionDuration, showText, showPercentageSign} = this.props;
        return (<div className="circular-progress-container">
                <div className="circular-progress-parent">
                    <CircularProgressbarWithChildren value={percentage} className='svg-circular-progress'
                            styles={buildStyles({
                                rotation: rotation,
                                strokeLinecap: strokeLinecap,
                                pathTransitionDuration: pathTransitionDuration,
                                pathColor: `${ overallScoreColor }`,
                                trailColor: `${ trialColor }`,
                            })}
                    >
                        <div>
                        <strong>{percentage}{showPercentageSign && "%"}</strong>
                        </div>
                    {showText && <div className='circular-progress-child-text'>{showText}</div>}
                    </CircularProgressbarWithChildren>
                </div>
        </div>);
    }
}

CircularProgressBar.defaultProps = {
    percentage: 50,
    trialColor:'#d6d6d6',
    overallScoreColor:"#FFB71B",
    rotation: 0.25,
    strokeLinecap: 'butt',
    pathTransitionDuration: 0.5,
    showText: ""
};
export default CircularProgressBar;


